import React, { useState } from "react";
import searchIcon from "../assets/images/search.svg";
import { baseUrl } from '../../utils/global';
import { useColorMode } from "theme-ui";

export const SearchBar = (): JSX.Element => {
  const [searchText, setSearchText] = useState<string>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };
  const hostname = window.location.hostname;
  const [colorMode, setColorMode] = useColorMode();
  const searchBg = colorMode === 'light' ? "#f7efe5" : "#374358";
  return (
    <div className="frame" style={{ backgroundColor: searchBg }}>
      {
        (
          hostname === "localhost" || hostname === "staging-v2.priority-proengc.com" ||
          baseUrl == "https://staging-apis-v2.priority-proengc.com/"
        ) &&
        <div style={{
          position: 'fixed',
          zIndex: 1000,
          background: 'red',
          color: 'white',
          fontSize: '15px',
          animation: 'blinker 1s linear infinite'
        }}>
          THIS IS A <b>{process.env.REACT_APP_ENV}</b> ENVIRONMENT. ANY CHANGES HAPPENED HERE ARE NOT CONSIDERED AS ACTUAL WORK
        </div>
      }
      <div className="div">
        <img className="search-normal" alt="Search normal" src={searchIcon} />
        <input
          type="text"
          className={`text-wrapper form-textcontrol ${isFocused ? 'focused' : ''}`}
          style={{ backgroundColor: searchBg }}
          placeholder="Search for anything..."
          value={searchText}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled
        />
      </div>
    </div>
  );
};
